module.exports = __webpack_public_path__ + "img/pc_dalou_bg.f008e21a.png";